class BESSAppProjectProjectWideEditorItem extends BESSAppProjectEditorItem {

    constructor(editor, itemData, itemView, inputs) {
        super(editor, itemData, itemView, inputs);
        this.itemView.find('.actions').remove();
        this.itemView.addClass('app-project-wide-item');
        this.itemView.removeClass('app-editor-item-std');
    }
}